// import { useEffect, useState } from "react";
// import { Tab, Tabs } from "react-bootstrap";
// import { useSearchParams } from "react-router-dom";
// import CreditsForCollabs from "./Credit settings/CreditsForCollabs";
// import CreditsForConsents from "./Credit settings/CreditsForConsents";

// const Credits = () => {
//  const [searchParams, setSearchParams] = useSearchParams();
//   const tabFromUrl = searchParams.get("tab");
//   const [upgradeCreditsTab, setUpgradeCreditsTab] = useState(
//     tabFromUrl || "credits-for-consents",
//   );
//   const handleTabChange = (key) => {
//     setUpgradeCreditsTab(key);
//     setSearchParams({ tab: key });
//   };

//   useEffect(() => {
//     if (tabFromUrl && tabFromUrl !== upgradeCreditsTab) {
//       setUpgradeCreditsTab(tabFromUrl);
//     }
//   }, [tabFromUrl]);

//   return (
//     <div className="scrollable-container" style={{ height: "100%" }}>
//       <h1 className="mb-4">
//         <strong>Credit Settings</strong>
//       </h1>

//       <Tabs
//         activeKey={upgradeCreditsTab}
//         onSelect={handleTabChange}
//         id="credits-settings-tabs"
//         className="mb-3"
//       >
//         <Tab eventKey="credits-for-consents" title="Credits for Consents">
//           <CreditsForConsents />
//         </Tab>

//         <Tab eventKey="credits-for-collabs" title="Credits for Collaborations">
//           <CreditsForCollabs />
//         </Tab>

       
//       </Tabs>
//     </div>
//   );
// };
// export default Credits;

import { useEffect, useState } from "react";
import { Button, Table, Toast, ToastContainer } from "react-bootstrap";
import adminApi from "../api/adminApi";

const Credits = () => {
  const [docCost, setDocCost] = useState(0);
  const [signCost, setSignCost] = useState(0);
  const [reviewerCost, setReviewerCost] = useState(0);
  const [collabCharge, setCollabCharge] = useState(0);
  const [creditPiceUnit, setCreditPiceUnit] = useState(0);
  const [creditHistory, setCreditHistory] = useState([]);
  const [showToast, setShowToast] = useState(false);
  const [isSaving, setIsSaving] = useState(false);

  // Fetch the credit history and pre-populate the form values on component mount
  useEffect(() => {
    fetchCreditHistory();
  }, []);

  const fetchCreditHistory = () => {
    adminApi.getCreditHistory().then((res) => {
      const latestSettings = res.data[0];  // Assuming the first entry is the most recent
      setCreditHistory(res.data);
      setDocCost(latestSettings.docCost);
      setSignCost(latestSettings.signCost);
      setReviewerCost(latestSettings.reviwerCost);
      setCollabCharge(latestSettings.collabCharge);
      setCreditPiceUnit(latestSettings.creditPiceUnit);
    });
  };

  const saveSettings = async () => {
    try {
      setIsSaving(true);
      console.log("Sending data to backend:", {
        docCost,
        signCost,
        reviewerCost,
        collabCharge,
        creditPiceUnit,
      });

      await adminApi.saveCreditSettings(docCost, signCost, reviewerCost, collabCharge, creditPiceUnit);
      setShowToast(true);
      fetchCreditHistory(); // Re-fetch credit history to update the displayed values
    } catch (error) {
      console.error("Error saving settings");
    } finally {
      setIsSaving(false);
    }
  };

  return (
    <div className="scrollable-container" style={{ height: "100%" }}>
      <ToastContainer position="top-end" className="p-3">
        <Toast
          onClose={() => setShowToast(false)}
          show={showToast}
          delay={3000}
          autohide
          bg="success"
        >
          <Toast.Header closeButton={false}>
            <strong className="me-auto">Success</strong>
          </Toast.Header>
          <Toast.Body>Settings updated!</Toast.Body>
        </Toast>
      </ToastContainer>

      <h1>
        <strong>Credit Settings</strong>
      </h1>
      <div style={{ marginBottom: 10 }}>
        <label>Document Credit: </label>
        <input
          type="number"
          value={docCost}
          onChange={(e) => setDocCost(parseInt(e.target.value))}
        />
      </div>
      <div style={{ marginBottom: 10 }}>
        <label>Signer Credit: </label>
        <input
          type="number"
          value={signCost}
          onChange={(e) => setSignCost(parseInt(e.target.value))}
        />
      </div>
      <div style={{ marginBottom: 10 }}>
        <label>Reviewer Credit: </label>
        <input
          type="number"
          value={reviewerCost}
          onChange={(e) => setReviewerCost(parseInt(e.target.value))}
        />
      </div>
      <div style={{ marginBottom: 10 }}>
        <label>Collaboration Credit: </label>
        <input
          type="number"
          step="0.01"
          value={collabCharge}
          onChange={(e) => setCollabCharge(parseFloat(e.target.value))}
        />
      </div>

      <div style={{ marginBottom: 10 }}>
        <label>Credit Price Unit: </label>
        <input
          type="number"
          step="0.01"
          value={creditPiceUnit}
          onChange={(e) => setCreditPiceUnit(parseFloat(e.target.value))}
        />
      </div>

      <Button onClick={saveSettings} disabled={isSaving}>
        {isSaving ? "Saving..." : "Save Settings"}
      </Button>

      <div style={{ marginTop: 30 }}>
        <h4>Credit History</h4>
        <Table striped bordered hover>
          <thead>
            <tr>
              <th>#</th>
              <th>Document Credit</th>
              <th>Signature Credit</th>
              <th>Reviewer Credit</th>
              <th>Collaboration Credit</th>
              <th>Credit Price Unit</th>
              <th>Updated At</th>
            </tr>
          </thead>
          <tbody>
            {creditHistory.map((entry, index) => (
              <tr key={index}>
                <td>{entry.id}</td>
                <td>{entry.docCost}</td>
                <td>{entry.signCost}</td>
                <td>{entry.reviwerCost}</td>
                <td>{entry.collabCharge}</td>
                <td>{entry.creditPiceUnit}</td>
                <td>{entry.updatedAt}</td>
              </tr>
            ))}
          </tbody>
        </Table>
      </div>
    </div>
  );
};

export default Credits;
